import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import api from '../../../Utils/Api'
import './HeaderMenu.css';

// const notificationsTestData = [
//     {
//         text: 'Новый тест по биологии',
//         link: '/resource/502552046775',
//         status: 'unseen',
//     },
//     {
//         text: 'Проверен "тип ресурса" по "краткое название курса"',
//         link: '/resource/502552046775',
//         status: 'unseen',
//     },
// ]


const HeaderMenu = ({ isOpened, onClose, logOut, notifications, username }) => {
    const [cookies, setCookie, removeCookie] = useCookies(['token']);
    const [token, setToken] = useState(cookies.token ? cookies.token : undefined);

    let unreadCount = 0;

    return (
        <>
            <div className={`headerMenu ${isOpened ? 'headerMenu_opened' : ''}`}>
                <div className='headerMenu__closeBtn' onClick={() => onClose(false, 0)} />
                {/* <div className='headerMenu__notifications'>
                    <div className={`${notificationsUp && notificationsUp.length > 0 ? 'headerMenu__notificationIcon_active' : 'headerMenu__notificationIcon'}`}></div>
                    {notificationsUp && notificationsUp.length > 0 ?
                        notificationsUp.map((notification, index) => {
                            if (!notification.is_read) {
                                unreadCount++;
                                if (unreadCount > 2) return null;
                                if (notification.link_related_resource)
                                    return ( 
                                        <div className='headerMenu__massage_wrap'>
                                            <Link to={`${
                                            'https' +
                                            notification.link_related_resource.split('https')[1]
                                          }`} key={index} onClick={() => handleRead(notification.id)}>
                                            <div className='headerMenu__notificationMessage'>
                                                <span className='headerMenu__notificationMessage_text'>{notification.text}</span>
                                            </div>
                                        </Link>
                                          <div className='headerMenu__deleteBtn' onClick={() => handleRead(notification.id)} />
                                        </div>
                                    );
                                else return (
                                    <div className='headerMenu__notificationMessage' key={index}>
                                        <span className='text'>{notification.text}</span>
                                        <div className='headerMenu__deleteBtn' onClick={() => handleRead(notification.id)} />
                                    </div>
                                );
                            }
                            return null;
                        })
                        :
                        <div className='headerMenu__notificationMessage_empty'>У вас нет новых уведомлений</div>
                    }
                    {notificationsUp && notificationsUp.length > 1 ?
                        <Link to={`/notifications`} key={1} onClick={() => onClose(false)}>
                            <div className='headerMenu__link'>
                                Показать все уведомления
                            </div>
                        </Link>
                        : ''
                    }
                </div> */}
                <div className='headerMenu__greeting'>{username ? `Привет, ${username}!` : 'Привет, Кристина!'}</div>
                {/* <Link to={'/'}className='headerMenu__link teachers' onClick={()=> onClose(false)}>Преподаватели</Link> */}
                <Link to={'/profile'} className='headerMenu__link profile' onClick={() => onClose(false)}>Настройка профиля</Link>
                <div className='headerMenu__link logout' onClick={() => { logOut(); onClose(false) }}>Выйти</div>
            </div>
        </>
    );
}
export default HeaderMenu

